import { Component, computed, input } from '@angular/core';
import { CrntButtonAlt } from '@essent/current-web-angular';
import { DeployUrlPipe } from '@innogy/utils/environment';
import { GenericLinkDirective, showLinkField } from '@core/jss-utils';

import { getAppButtons, showButtonGroup } from '../utils/hero.utils';
import type { Hero } from '../models/hero.model';

@Component({
  selector: 'wl-hero-button-group',
  standalone: true,
  imports: [CrntButtonAlt, DeployUrlPipe, GenericLinkDirective],
  templateUrl: './hero-button-group.component.html',
  styleUrls: [
    './hero-button-group.component.ed.scss',
    './hero-button-group.component.essent.scss',
  ],
})
export class HeroButtonGroupComponent {
  readonly hero = input.required<Partial<Hero>>();
  readonly inverted = input<boolean>(false);
  readonly large = input<boolean>(false);

  readonly showButtonGroup = computed(() => showButtonGroup(this.hero()));
  readonly appButtons = computed(() => getAppButtons(this.hero()));

  readonly primaryButton = computed(() => this.hero().primaryButton);
  readonly secondaryButton = computed(() => this.hero().secondaryButton);

  readonly showPrimaryButton = computed(() =>
    showLinkField(this.primaryButton())
  );
  readonly showSecondaryButton = computed(() =>
    showLinkField(this.secondaryButton())
  );
}
